/**
 * Parses a date string safely, handling common formats and
 * working around parsing quirks on iOS/WebKit (Safari) engines.
 *
 * iOS Safari (JavaScriptCore) fails to parse ISO-like dates separated by a space
 * (e.g., "YYYY-MM-DD HH:mm:ss") and expects the standard "T" separator instead.
 */
function safeParseDate(dateString?: string): Date {
  if (!dateString) {
    return new Date(NaN)
  }

  let normalized = dateString.trim()

  // 1. Handle Brazilian date format: "DD/MM/YYYY" or "DD/MM/YYYY HH:mm:ss"
  const brDateRegex =
    /^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2}):(\d{2}))?$/
  const brMatch = normalized.match(brDateRegex)
  if (brMatch) {
    const [, day, month, year, hours = '00', minutes = '00', seconds = '00'] =
      brMatch
    return new Date(
      Number(year),
      Number(month) - 1, // JS Month is 0-indexed
      Number(day),
      Number(hours),
      Number(minutes),
      Number(seconds)
    )
  }

  // 2. Handle space separators in ISO-like strings (with optional timezone offset):
  // E.g., "2026-06-03 15:00:00 +0000" -> "2026-06-03T15:00:00+0000"
  const isoWithSpaceRegex =
    /^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2}:\d{2}(?:\.\d+)?)(?:\s+([+-]\d{2}:?\d{2}|Z))?$/
  const isoMatch = normalized.match(isoWithSpaceRegex)
  if (isoMatch) {
    const [, datePart, timePart, tzPart = ''] = isoMatch
    normalized = `${datePart}T${timePart}${tzPart}`
  }

  return new Date(normalized)
}

export default safeParseDate
